import { createRoot } from "react-dom/client";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/primitives/alert-dialog";

async function showDialog(
  title: string,
  description: string,
  okLabel: string = "Ok",
  cancelLabel: string = "Cancel",
): Promise<boolean> {
  return new Promise((resolve) => {
    const containerElement = document.createElement("div");
    document.body.appendChild(containerElement);
    const root = createRoot(containerElement);

    const handleClose = (result: boolean) => {
      root.unmount();
      containerElement.remove();
      resolve(result);
    };

    queueMicrotask(() => {
      root.render(
        <AlertDialog open={true} onOpenChange={() => handleClose(false)}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{title}</AlertDialogTitle>
              <AlertDialogDescription>{description}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel onClick={() => handleClose(false)}>
                {cancelLabel}
              </AlertDialogCancel>
              <AlertDialogAction onClick={() => handleClose(true)}>
                {okLabel}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>,
      );
    });
  });
}

export default showDialog;
